/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchContainersShelfResponse } from './search-containers-shelf-response';


export interface SearchContainersRackResponse { 
    id: string;
    number: number;
    shelves: Array<SearchContainersShelfResponse>;
}

